import { v4 as uuidv4 } from 'uuid';

import { type MultiButtonOptionType } from 'app/main/components/buttons/MultiButton';
import { type ViewItemButtonProps } from 'app/main/components/page-layouts/view/ViewPage';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

const buttons: MultiButtonOptionType<ViewItemButtonProps>[] = [
	{
		name: 'PHONECALLS_ACTIONS_ADD_COMPANY',
		icon: 'domain',
		iconAdd: true,
		disabled: ({ model }) => model.peop_uid || model.comp_uid || model.user_uid,
		action: ({ dispatch, model, updateRefresh }) => {
			dispatch(
				showFastAddDialog({
					module: 'companies',
					updateRefresh,
					model: {
						comp_title: model.phca_contact_title,
						comp_phones: [
							{
								phon_uid: uuidv4(),
								phon_title: model.phca_src_number || model.phca_dst_number || model.phca_number
							}
						]
					}
				})
			);
		}
	},
	{
		name: 'PHONECALLS_ACTIONS_ADD_PERSON',
		icon: 'card-account-details-outline',
		iconAdd: true,
		disabled: ({ model }) => model.peop_uid || model.comp_uid || model.user_uid,
		action: ({ dispatch, model, updateRefresh }) => {
			dispatch(
				showFastAddDialog({
					module: 'people',
					updateRefresh,
					model: {
						peop_name: model.phca_contact_name,
						peop_surname: model.phca_contact_surname,
						peop_phones: [
							{
								phon_uid: uuidv4(),
								phon_title: model.phca_src_number || model.phca_dst_number || model.phca_number
							}
						]
					}
				})
			);
		}
	},
	{
		name: 'PHONECALLS_ACTIONS_ADD_PHONE',
		icon: 'phone',
		iconAdd: true,
		disabled: ({ model }) => model.phon_uid,
		action: ({ dispatch, model, updateRefresh }) => {
			dispatch(
				showFastAddDialog({
					module: 'phones',
					updateRefresh,
					model: {
						phon_title: model.phca_src_number || model.phca_dst_number || model.phca_number,
						phon_description: model.phca_contact_title
					}
				})
			);
		}
	},
	{
		name: 'PHONECALLS_ACTIONS_ADD_ACTIVITY',
		icon: 'puzzle-outline',
		iconAdd: true,
		disabled: ({ model }) => model.user_uid,
		action: ({ dispatch, model, updateRefresh }) => {
			const modu_short = model.phon_table === 'people' ? 'peop' : 'comp';

			dispatch(
				showFastAddDialog({
					module: 'activities',
					updateRefresh,
					model: {
						[`acti_${modu_short}_uid`]: model[`${modu_short}_uid`],
						acti_descriptionhtml: model.phca_note
					}
				})
			);
		}
	},
	{
		name: 'VIEW_ITEM_BUTTON_NEW_WORKREPORT',
		icon: 'text-box-multiple-outline',
		iconAdd: true,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('workreports') || authorizer.cannot('create', 'workreports'),
		action: ({ dispatch, updateRefresh, model }) =>
			dispatch(
				showFastAddDialog({
					module: 'workreports',
					updateRefresh,
					model: {
						wore_title: model.comp_title
							? model.phon_description
								? `Chiamata con ${model.comp_title} - ${model.phon_description}`
								: `Chiamata con ${model.comp_title}`
							: '',
						wore_comp_uid: model.comp_uid,
						wore_length_minutes: Math.round(model.phca_minutes),
						wore_date: model.phca_date
					}
				})
			)
	}
];

export default buttons;
